<div class="sidebar-ad"
     id="ads-banner-{{position}}">
        <img src="../../../assets/dummy/left_Skyscraper.jpg"
             class="skyscraper-ad" alt=""
             *ngIf="position === 'LEFT'">
  <img src="../../../assets/dummy/right_Skyscraper.jpg"
             class="skyscraper-ad" alt=""
             *ngIf="position === 'RIGHT'">
</div>
